/** @jsx jsx */
import { Box, Container, Flex, Heading, Inline, Stack, Status } from "@eworkit/iris";
import React, { FC } from "react";
import { jsx } from "theme-ui";

interface ListViewHeaderProps {
  header: string;
  count?: number;
  addButton?: React.ReactNode;
}

export const ListViewHeader: FC<ListViewHeaderProps> = ({ header, count, addButton, children }) => {
  return (
    <React.Fragment>
      <Stack>
        <Box bg="n0" borderColor="n100" borderBottom="primary" borderBottomWidth="xs" py="md">
          <Container>
            <Box px="sm">
              <Stack gap="sm">
                <Flex justifyContent="space-between">
                  <Inline alignItems="center" gap="xs">
                    <Heading size="h-md">{header}</Heading>
                    {count !== undefined && <Status variant="secondary">{count}</Status>}
                  </Inline>

                  {addButton}
                </Flex>

                {children}
              </Stack>
            </Box>
          </Container>
        </Box>
      </Stack>
    </React.Fragment>
  );
};
